import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, ROUTE_PATH } from "../../app/constants";

import { Header, Button, ErrorMark } from "../../components/RegularComponents";
import DateSelectionForm from "../../components/DateSelectionForm";

import TopNavigationBar from "../TopNavigationBar";
import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../app/errors";

const MORTGAGE_APPLICATION_PROPERTY = "companyFiscalEndDate";

export const CompanyFiscalEndDate = (props) => {
  // Will probably need a special state selector here
  const companyFiscalEndDate = useSelector(
    (state) => state.primaryAgencyApplication.application.businessLicenceData.companyFiscalEndDate
  );

  const { isModal = false, onEditSave = () => {} } = props;

  const dispatch = useDispatch();

  const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
  const applicationMode = APPLICATION_MODE_NEW

  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [fiscalEndDate, setFiscalEndDate] = useState(companyFiscalEndDate); 
  const [showValidationError, setShowValidationError] = useState(false);

  const validateData = () => {
    return !!fiscalEndDate;
  }
  
  const handleSaveAndNext = () => {

    if(!validateData()){
      setShowValidationError(true);
      return;
    }

    //reset errors
    setApplicationSaveError(false);
    setShowValidationError(false);

    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: fiscalEndDate,
    };
    dispatch(setMortgageProperty(update));

    dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
      .then(data => {
        dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_UPLOAD_CRIMINAL_RECORD_CHECK_AGENCY}`))
          // On to the next item
          // dispatch(
          //   push({
          //     pathname : `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_UPLOAD_CRIMINAL_RECORD_CHECK}`,
          //     state : {
          //       primaryAgencyApplication : true
          //     }
          //   }
          //   )
          // );
      })
      .catch(err => {
        setApplicationSaveError(true)
      })
  };

  const handleSaveandClose = () => {

    if(!validateData()){
      setShowValidationError(true);
      return;
    }

    //reset errors
    setApplicationSaveError(false);
    setShowValidationError(false);

    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: fiscalEndDate,
    };
    dispatch(setMortgageProperty(update));
    
    onEditSave();
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar {...props} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "30px" }}
                  id="company-fiscal-end-date-header"
                  header="Provide fiscal year end date for your company"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-8">
            <label id="company-fiscal-end-date-label" className="ns-label">
              Fiscal year end date
            </label>
            <p>Enter a number for day and month. For example: 17 11</p>
          </div>
        </div>

        {/* Date */}
        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((showValidationError) ? " has-error ns-fieldset-message-error" : "")
              }
            >
            <fieldset className="ns-fieldset">
              {/* {fiscalEndDateError && (
                <span
                  id={"company-fiscal-end-date-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString("Enter your company's fiscal end date")}
                </span>
              )} */}
              <DateSelectionForm
                id={"company-fiscal-end-date-date"}
                date={fiscalEndDate}
                showValidationError={showValidationError}
                hideYear
                onDateChange={(date) => {
                  setFiscalEndDate(date);
                  setShowValidationError(false);
                }}
              />
            </fieldset>
            </div>
          </div>
        </div>

        <div className="row">
          <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
            <Button
              id="company-fiscal-end-date-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleSaveAndNext : handleSaveandClose}
            />
            {applicationSaveError && ErrorMark()}
            {applicationSaveError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
            {showValidationError && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CHECK_FIELDS}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
